export default __webpack_public_path__ + "static/media/Adi.5c483c14.jpg";